/*
  DUS loading-page checkout bridge.
  Goal: keep tracking values from Koeln (_fbp/_fbc) stable while rebuilding cart on dus.colognewatch.de.

  Supported URL formats on /pages/loading-page:
    - Preferred (v9.4.1+):  ?h=<handle>&sku=<sku>&q=<qty>   (SKU-Lookup, server-free)
    - Legacy (Cloudways):   ?v_id=<dus_variant_id>&q=<qty>  (direct DUS variant id)
*/
(function () {
  "use strict";

  var LOCK_TTL_SECONDS = 60 * 60 * 24 * 90;
  var LOCK_ENFORCE_DURATION_MS = 30000;
  var LOCK_ENFORCE_INTERVAL_MS = 250;
  var COOKIE_DOMAIN = ".colognewatch.de";
  var LOCK_PREFIX = "cw_tracking_lock_";
  var PENDING_CHECKOUT_KEY = "cw_dus_pending_checkout";
  var PENDING_CHECKOUT_TTL_MS = 2 * 60 * 1000;

  function isLoadingPage() {
    var hasMetaPage = typeof meta !== "undefined" && meta && meta.page && meta.page.pageType === "page";
    return hasMetaPage && window.location.pathname.indexOf("loading-page") !== -1;
  }

  function getParam(params, keys) {
    var i;
    for (i = 0; i < keys.length; i += 1) {
      var value = params.get(keys[i]);
      if (value) {
        return value;
      }
    }
    return null;
  }

  function parseIntSafe(value, fallbackValue) {
    var parsed = parseInt(value, 10);
    if (isNaN(parsed) || parsed < 1) {
      return fallbackValue;
    }
    return parsed;
  }

  function setCookie(name, value, maxAgeSeconds, withDomain) {
    if (!value) {
      return;
    }

    var cookie = name + "=" + encodeURIComponent(value) + "; Max-Age=" + maxAgeSeconds + "; Path=/; SameSite=Lax";

    if (window.location.protocol === "https:") {
      cookie += "; Secure";
    }

    if (withDomain) {
      cookie += "; Domain=" + COOKIE_DOMAIN;
    }

    document.cookie = cookie;
  }

  function readCookie(name) {
    var prefix = name + "=";
    var parts = document.cookie ? document.cookie.split("; ") : [];
    var i;

    for (i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(prefix) === 0) {
        return decodeURIComponent(parts[i].substring(prefix.length));
      }
    }

    return null;
  }

  function setTrackingCookie(name, value) {
    if (!value) {
      return;
    }

    // Nur Host-Cookie: eine Zustimmung in DUS soll keine Cookies im Köln-Scope erzeugen.
    setCookie(name, value, LOCK_TTL_SECONDS, false);
  }

  function saveLock(name, value) {
    if (!value) {
      return;
    }

    try {
      var payload = {
        value: value,
        expiresAt: Date.now() + LOCK_TTL_SECONDS * 1000
      };
      window.localStorage.setItem(LOCK_PREFIX + name, JSON.stringify(payload));
    } catch (error) {
      // Ignore storage errors (private mode, quota, etc.)
    }
  }

  function readLock(name) {
    try {
      var raw = window.localStorage.getItem(LOCK_PREFIX + name);
      if (!raw) {
        return null;
      }

      var payload = JSON.parse(raw);
      if (!payload || !payload.value) {
        return null;
      }

      if (payload.expiresAt && Date.now() > payload.expiresAt) {
        window.localStorage.removeItem(LOCK_PREFIX + name);
        return null;
      }

      return payload.value;
    } catch (error) {
      return null;
    }
  }

  function startCookieEnforcer(values) {
    if (!values._fbp && !values._fbc) {
      return;
    }

    var startedAt = Date.now();
    var timerId = window.setInterval(function () {
      if (Date.now() - startedAt > LOCK_ENFORCE_DURATION_MS) {
        window.clearInterval(timerId);
        return;
      }

      if (values._fbp) {
        setTrackingCookie("_fbp", values._fbp);
      }

      if (values._fbc) {
        setTrackingCookie("_fbc", values._fbc);
      }
    }, LOCK_ENFORCE_INTERVAL_MS);

    window.addEventListener("beforeunload", function () {
      window.clearInterval(timerId);
    });
  }

  // Meta-Kennungen (_fbp/_fbc) dürfen nur mit Marketing-Zustimmung als Cookie bzw. im
  // localStorage gespeichert werden. Die Consent-API ist in DUS nicht automatisch geladen,
  // deshalb per Shopify.loadFeatures nachladen; ohne Antwort gilt: keine Zustimmung.
  var CONSENT_TIMEOUT_MS = 3000;

  function marketingConsent() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.marketingAllowed === "function" && privacy.marketingAllowed());
    } catch (error) {
      return false;
    }
  }

  function hasPrivacyApi() {
    return !!(window.Shopify && window.Shopify.customerPrivacy);
  }

  function whenPrivacyApiReady(callback) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      callback();
    }

    if (hasPrivacyApi()) {
      finish();
      return;
    }

    window.setTimeout(finish, CONSENT_TIMEOUT_MS);

    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
          if (error && typeof console !== "undefined" && console.warn) {
            console.warn("DUS consent API could not be loaded:", error);
          }
          finish();
        });
      }
    } catch (error) {
      finish();
    }
  }

  function expireCookie(name, withDomain) {
    var cookie = name + "=; Max-Age=0; Path=/; SameSite=Lax";
    if (window.location.protocol === "https:") {
      cookie += "; Secure";
    }
    if (withDomain) {
      cookie += "; Domain=" + COOKIE_DOMAIN;
    }
    document.cookie = cookie;
  }

  // Ohne Zustimmung: Locks und von diesem Skript gesetzte Cookies entfernen (auch Altbestand
  // vor 20.10.2026). Das Domain-Cookie nur, wenn es nachweislich aus unserem Lock stammt,
  // damit ein legitimes Köln-Cookie erhalten bleibt.
  function clearTrackingLocks() {
    ["_fbp", "_fbc"].forEach(function (name) {
      var locked = readLock(name);
      expireCookie(name, false);
      // Nach dem Löschen des Host-Cookies ist nur noch ein evtl. Domain-Cookie lesbar.
      if (locked && readCookie(name) === locked) {
        expireCookie(name, true);
      }
    });
    try {
      window.localStorage.removeItem(LOCK_PREFIX + "_fbp");
      window.localStorage.removeItem(LOCK_PREFIX + "_fbc");
    } catch (error) {
      // Ignore storage errors (private mode, quota, etc.)
    }
  }

  function resolveTrackingValuesWithConsent(params) {
    whenPrivacyApiReady(function () {
      if (marketingConsent()) {
        resolveTrackingValues(params);
      } else if (hasPrivacyApi()) {
        // Zustimmung fehlt bzw. wurde widerrufen: alte 90-Tage-Locks entfernen.
        clearTrackingLocks();
      }
    });
  }

  // ===== Cookie-Entscheidung aus Köln übernehmen =====
  // Köln übergibt die im Kölner Banner getroffene Entscheidung als cw_consent=m<0|1>a<0|1>p<0|1>.
  // Übernommen wird sie nur bei Weiterleitung von www.colognewatch.de (Referrer), damit fremde
  // Links keine Zustimmung setzen können. Ablehnungen werden ebenso übernommen.
  var CONSENT_PARAM = "cw_consent";
  var CONSENT_SOURCE_ORIGIN = "https://www.colognewatch.de";
  var CONSENT_APPLY_TIMEOUT_MS = 2500;

  function parseTransferredConsent(params) {
    var raw = params.get(CONSENT_PARAM);
    if (!raw || !/^m[01]a[01]p[01]$/.test(raw)) {
      return null;
    }
    return {
      marketing: raw.charAt(1) === "1",
      analytics: raw.charAt(3) === "1",
      preferences: raw.charAt(5) === "1"
    };
  }

  function cameFromKoeln() {
    try {
      return !!document.referrer && new URL(document.referrer).origin === CONSENT_SOURCE_ORIGIN;
    } catch (error) {
      return false;
    }
  }

  // Liefert immer ein Promise, das nie fehlschlägt (true = übernommen).
  function applyTransferredConsent(params) {
    var consent = parseTransferredConsent(params);
    if (!consent || !cameFromKoeln()) {
      return Promise.resolve(false);
    }

    return new Promise(function (resolve) {
      var done = false;
      function finish(applied) {
        if (done) return;
        done = true;
        resolve(applied);
      }

      // Erst nach dem load-Event setzen: Vorher gesetzte Zustimmung verwirft Shopify in Chromium/
      // Firefox beim folgenden Request, sobald utm_* im Spiel sind (gemessen 20.10.2026, Audit B1).
      whenPageLoaded(function () {
        window.setTimeout(function () {
          finish(false);
        }, CONSENT_APPLY_TIMEOUT_MS);

        whenPrivacyApiReady(function () {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy || typeof privacy.setTrackingConsent !== "function") {
          finish(false);
          return;
        }
        try {
          privacy.setTrackingConsent(
            { marketing: consent.marketing, analytics: consent.analytics, preferences: consent.preferences },
            function (result) {
              finish(!(result && result.error));
            }
          );
        } catch (error) {
          finish(false);
        }
        });
      });
    });
  }

  function whenPageLoaded(callback) {
    if (document.readyState === "complete") {
      callback();
      return;
    }
    window.addEventListener("load", function () {
      callback();
    });
  }

  function resolveTrackingValues(params) {
    var incomingFbp = getParam(params, ["_fbp"]);
    var incomingFbc = getParam(params, ["_fbc"]);
    var resolvedFbp;
    var resolvedFbc;

    if (incomingFbp) {
      saveLock("_fbp", incomingFbp);
      resolvedFbp = incomingFbp;
    } else {
      resolvedFbp = readLock("_fbp") || readCookie("_fbp");
    }

    if (incomingFbc) {
      saveLock("_fbc", incomingFbc);
      resolvedFbc = incomingFbc;
    } else {
      resolvedFbc = readLock("_fbc") || readCookie("_fbc");
    }

    if (resolvedFbp) {
      setTrackingCookie("_fbp", resolvedFbp);
    }

    if (resolvedFbc) {
      setTrackingCookie("_fbc", resolvedFbc);
    }

    startCookieEnforcer({
      _fbp: resolvedFbp,
      _fbc: resolvedFbc
    });
  }

  function collectLegacyVariants(params) {
    var variantIds = params.getAll("v_id");
    var quantities = params.getAll("q");
    var variants = [];
    var i;

    for (i = 0; i < variantIds.length; i += 1) {
      if (!variantIds[i]) {
        continue;
      }

      variants.push({
        id: variantIds[i],
        quantity: parseIntSafe(quantities[i] || quantities[0] || "1", 1)
      });
    }

    return variants;
  }

  function collectSkuLookups(params) {
    var handles = params.getAll("h");
    var skus = params.getAll("sku");
    var quantities = params.getAll("q");
    var lookups = [];
    var i;

    for (i = 0; i < handles.length; i += 1) {
      if (!handles[i] || !skus[i]) {
        continue;
      }

      lookups.push({
        handle: handles[i],
        sku: skus[i],
        quantity: parseIntSafe(quantities[i] || quantities[0] || "1", 1)
      });
    }

    return lookups;
  }

  function resolveVariantBySku(lookup) {
    return fetch("/products/" + encodeURIComponent(lookup.handle) + ".js", {
      headers: { "Accept": "application/json" }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to fetch product " + lookup.handle + " (HTTP " + response.status + ")");
        }
        return response.json();
      })
      .then(function (product) {
        var variants = product && product.variants ? product.variants : [];
        var targetSku = String(lookup.sku).trim().toUpperCase();
        var match = null;
        var i;

        for (i = 0; i < variants.length; i += 1) {
          if (variants[i] && variants[i].sku && String(variants[i].sku).trim().toUpperCase() === targetSku) {
            match = variants[i];
            break;
          }
        }

        if (!match) {
          throw new Error("SKU " + lookup.sku + " not found on product " + lookup.handle);
        }

        if (match.available === false) {
          throw new Error("SKU " + lookup.sku + " is not available on product " + lookup.handle);
        }

        return {
          id: match.id,
          quantity: lookup.quantity,
          sku: lookup.sku
        };
      });
  }

  function appendTrackingParams(targetUrl) {
    var keepParams = [
      "fbclid", "gclid", "gbraid", "wbraid", "gad_source", "gad_campaignid",
      "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id",
      "_ga", "_gl"
    ];
    var params;

    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return targetUrl;
    }

    keepParams.forEach(function (p) {
      var v = params.get(p);
      if (v) {
        targetUrl.searchParams.append(p, v);
      }
    });

    return targetUrl;
  }

  function redirectToCartPermalink(variants) {
    var pairs = [];

    variants.forEach(function (variant) {
      if (!variant || !variant.id) {
        return;
      }

      pairs.push(encodeURIComponent(variant.id) + ":" + encodeURIComponent(variant.quantity || 1));
    });

    if (pairs.length === 0) {
      throw new Error("No DUS variants available for cart permalink");
    }

    var cartUrl = new URL("/cart/" + pairs.join(","), window.location.origin);
    window.location.href = appendTrackingParams(cartUrl).toString();
  }

  function rememberPendingCheckout(variants, skuLookups, legacyVariants) {
    try {
      window.sessionStorage.setItem(PENDING_CHECKOUT_KEY, JSON.stringify({
        createdAt: Date.now(),
        variants: variants || [],
        skuLookups: skuLookups || [],
        legacyVariants: legacyVariants || []
      }));
    } catch (error) {
      // Ignore storage errors. The primary availability gate already happened before the redirect.
    }
  }

  function readPendingCheckout() {
    try {
      var raw = window.sessionStorage.getItem(PENDING_CHECKOUT_KEY);
      var pending;

      if (!raw) {
        return null;
      }

      pending = JSON.parse(raw);

      if (!pending || !pending.createdAt || Date.now() - pending.createdAt > PENDING_CHECKOUT_TTL_MS) {
        window.sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
        return null;
      }

      return pending;
    } catch (error) {
      return null;
    }
  }

  function clearPendingCheckout() {
    try {
      window.sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function cartContainsPendingVariant(cart, pending) {
    var lines = cart && cart.items ? cart.items : [];
    var variants = pending && pending.variants ? pending.variants : [];
    var pendingIds = {};
    var i;

    for (i = 0; i < variants.length; i += 1) {
      if (variants[i] && variants[i].id) {
        pendingIds[String(variants[i].id)] = true;
      }
    }

    if (Object.keys(pendingIds).length === 0) {
      return false;
    }

    for (i = 0; i < lines.length; i += 1) {
      if (lines[i] && pendingIds[String(lines[i].variant_id)]) {
        return true;
      }
    }

    return false;
  }

  function maybeRenderPendingCartFailure() {
    var pending;

    if (window.location.pathname.indexOf("/cart") !== 0) {
      return;
    }

    pending = readPendingCheckout();

    if (!pending) {
      return;
    }

    fetch("/cart.js", {
      headers: { "Accept": "application/json" }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to fetch cart (HTTP " + response.status + ")");
        }
        return response.json();
      })
      .then(function (cart) {
        if (cartContainsPendingVariant(cart, pending)) {
          clearPendingCheckout();
          return;
        }

        renderUnavailableMessage(pending.skuLookups, pending.legacyVariants);
        clearPendingCheckout();
      })
      .catch(function (error) {
        console.error("DUS cart permalink verification failed; showing unavailable message:", error);
        renderUnavailableMessage(pending.skuLookups, pending.legacyVariants);
        clearPendingCheckout();
      });
  }

  function getErrorSkuList(skuLookups, legacyVariants) {
    var values = [];

    if (skuLookups && skuLookups.length > 0) {
      skuLookups.forEach(function (lookup) {
        if (lookup && lookup.sku) {
          values.push(String(lookup.sku).trim());
        }
      });
    }

    if (values.length === 0 && legacyVariants && legacyVariants.length > 0) {
      legacyVariants.forEach(function (variant) {
        if (variant && variant.id) {
          values.push("Variant " + variant.id);
        }
      });
    }

    return values.length > 0 ? values.join(", ") : "nicht verfügbar";
  }

  function renderUnavailableMessage(skuLookups, legacyVariants) {
    var storageNumber = getErrorSkuList(skuLookups, legacyVariants);
    var target = document.querySelector("main") || document.body;

    target.innerHTML =
      '<section style="min-height:70vh;display:flex;align-items:center;justify-content:center;padding:48px 18px;background:#fff;">'
      + '<div style="width:min(720px,100%);background:#fff;border:1px solid rgba(28,27,27,.12);box-shadow:0 18px 50px rgba(28,27,27,.08);padding:34px 28px;text-align:left;">'
      + '<p style="margin:0 0 10px;font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#777;">Cologne Watch Düsseldorf</p>'
      + '<h1 style="margin:0 0 16px;font-size:clamp(26px,4vw,38px);line-height:1.15;color:#1c1b1b;">Dieser Artikel ist in unserem Düsseldorfer Standort leider nicht mehr verfügbar.</h1>'
      + '<p style="margin:0 0 18px;font-size:16px;line-height:1.6;color:#4b4b4b;">Gerade bei stark nachgefragten Uhren kann es passieren, dass ein Artikel bereits verkauft wurde, obwohl die Verfügbarkeit noch kurzzeitig angezeigt wurde. Der Kauf kann deshalb aktuell nicht automatisch abgeschlossen werden.</p>'
      + '<div style="margin:22px 0;padding:16px 18px;background:#f3f3f3;border-left:3px solid #1c1b1b;">'
      + '<p style="margin:0;font-size:14px;color:#777;">Lagernummer</p>'
      + '<p style="margin:4px 0 0;font-size:22px;font-weight:600;color:#1c1b1b;">' + escapeHtml(storageNumber) + '</p>'
      + '</div>'
      + '<div style="display:grid;gap:6px;margin:0 0 24px;font-size:15px;line-height:1.6;color:#1c1b1b;">'
      + '<strong>Cologne Watch Düsseldorf</strong>'
      + '<span>Schadowstrasse 11, 40212 Düsseldorf</span>'
      + '<a href="tel:+4921186932020" style="color:#1c1b1b;text-decoration:underline;">+49 (0) 211 869 320 20</a>'
      + '<a href="mailto:dus@colognewatch.de?subject=Anfrage%20zu%20Lagernummer%20' + encodeURIComponent(storageNumber) + '" style="color:#1c1b1b;text-decoration:underline;">dus@colognewatch.de</a>'
      + '</div>'
      + '<div style="display:flex;flex-wrap:wrap;gap:10px;">'
      + '<a href="mailto:dus@colognewatch.de?subject=Anfrage%20zu%20Lagernummer%20' + encodeURIComponent(storageNumber) + '" style="display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0 18px;background:#1c1b1b;color:#fff;text-decoration:none;font-weight:600;">Düsseldorf kontaktieren</a>'
      + '<a href="https://www.colognewatch.de" style="display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0 18px;border:1px solid #1c1b1b;color:#1c1b1b;text-decoration:none;font-weight:600;">Zurück zu colognewatch.de</a>'
      + '</div>'
      + '</div>'
      + '</section>';
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function processLoadingPage() {
    var params = new URLSearchParams(window.location.search);

    var consentApplied = applyTransferredConsent(params);
    consentApplied.then(function () {
      resolveTrackingValuesWithConsent(params);
    });

    var skuLookups = collectSkuLookups(params);
    var legacyVariants = collectLegacyVariants(params);

    var variantsPromise;

    if (skuLookups.length > 0) {
      // New (server-free) path: resolve DUS variant ids locally via /products/<handle>.js
      variantsPromise = Promise.all(skuLookups.map(resolveVariantBySku));
    } else if (legacyVariants.length > 0) {
      // Legacy path: Cloudways backend provided ready-to-use DUS variant ids
      variantsPromise = Promise.resolve(legacyVariants);
    } else {
      return;
    }

    // Erst weiterleiten, wenn die übernommene Zustimmung gesetzt ist (nach load, max. 2,5 s),
    // damit der Checkout sie bereits kennt.
    Promise.all([variantsPromise, consentApplied])
      .then(function (results) {
        var variants = results[0];
        rememberPendingCheckout(variants, skuLookups, legacyVariants);
        redirectToCartPermalink(variants);
      })
      .catch(function (error) {
        console.error("DUS loading-page checkout failed; showing unavailable message:", error);
        renderUnavailableMessage(skuLookups, legacyVariants);
      });
  }

  if (isLoadingPage()) {
    processLoadingPage();
  } else {
    maybeRenderPendingCartFailure();
    // Altbestand auf allen übrigen Seiten bereinigen, wenn keine Marketing-Zustimmung vorliegt.
    whenPrivacyApiReady(function () {
      if (hasPrivacyApi() && !marketingConsent()) {
        clearTrackingLocks();
      }
    });
  }
})();
